// Get the modals
var cutPileModal = document.getElementById("cutPile");
var loopPileModal = document.getElementById("loopPile");

// Get the buttons that opens the modal buttons
var cutPileBtn = document.querySelector("input[value='Cut Pile']");
var loopPileBtn = document.querySelector("input[value='Loop Pile']");

// Get the buttons that opens the modals
var cutPileModalBtn = document.querySelector(".cutPileModalButton");
var loopPileModalBtn = document.querySelector(".loopPileModalButton");

// Get the <span> element that closes the modal
var cutPileSpan = document.getElementById("cutPileClose");
var loopPileSpan = document.getElementById("loopPileClose");

// When the user clicks on the button, open the modal
if (cutPileBtn) {
  cutPileBtn.onclick = function () {
    cutPileModalBtn.classList.add("active");
    loopPileModalBtn.classList.remove("active");
  };
  cutPileModalBtn.onclick = function () {
    cutPileModal.classList.add("active");
    document.documentElement.classList.add("overflowHidden");
  };
  // When the user clicks on <span> (x), close the modal
  cutPileSpan.onclick = function () {
    cutPileModal.classList.remove("active");
    document.documentElement.classList.remove("overflowHidden");
  };
}
if (loopPileBtn) {
  loopPileBtn.onclick = function () {
    loopPileModalBtn.classList.add("active");
    cutPileModalBtn.classList.remove("active");
  };
  loopPileModalBtn.onclick = function () {
    loopPileModal.classList.add("active");
    document.documentElement.classList.add("overflowHidden");
  };

  loopPileSpan.onclick = function () {
    loopPileModal.classList.remove("active");
    document.documentElement.classList.remove("overflowHidden");
  };
}

if (loopPileModalBtn || cutPileModalBtn) {
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == loopPileModal || event.target == cutPileModal) {
      cutPileModal.classList.remove("active");
      loopPileModal.classList.remove("active");
      document.documentElement.classList.remove("overflowHidden");
    }
  };
}

document.addEventListener("DOMContentLoaded", function () {
  const showMoreBtn = document.querySelector(".show-more-button-main");
  const remainingCount = document.querySelector(".remainings-count-main");
  const hiddenColors = document.querySelectorAll(
    "#otherColorsContainer .flexInp.hidden"
  );

  if (showMoreBtn) {
    // Set initial remaining count
    if (remainingCount) {
      remainingCount.textContent = hiddenColors.length;
    }

    // Click ve touch events ekle
    ["click", "touchstart"].forEach((evt) =>
      showMoreBtn.addEventListener(
        evt,
        function (e) {
          e.preventDefault();

          hiddenColors.forEach((color) => {
            color.classList.toggle("show");
          });

          // + isaretini button'un ilk text node'undan aliyoruz
          const buttonTextNode = showMoreBtn.childNodes[0];

          if (buttonTextNode.textContent.trim() === "+") {
            buttonTextNode.textContent = "-";
            remainingCount.style.display = "none";
          } else {
            buttonTextNode.textContent = "+";
            remainingCount.style.display = "inline";
          }
        },
        { passive: false }
      )
    );
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const noBorderOption = document.querySelector(".no-border-option");

  if (noBorderOption) {
    noBorderOption.addEventListener("click", function (e) {
      e.preventDefault();

      // Bordure overlay'i bul ve sadece background'i kaldir
      const bordureOverlay = document.querySelector(".bordure-overlay");
      if (bordureOverlay) {
        bordureOverlay.style.backgroundImage = "none";

        // Notify zoom system of bordure removal
        const event = new CustomEvent("bordureChanged", {
          detail: {
            bordureWrapper: bordureOverlay,
            bordureColorLink: null,
          },
        });
        document.dispatchEvent(event);
      }

      // No border secenegini aktif yap
      document.querySelectorAll(".flexInp").forEach((item) => {
        item.classList.remove("active");
      });
      noBorderOption.classList.add("active");
    });
  }
});

// Other colors swatch: swap product (title/price/media) without a full page reload.
// The swatches link to separate Shopify products (metafield reference), so we fetch
// the target product's page, pull out the ".right-section" (media + info + productData)
// and swap it in place. Custom elements inside (media-gallery, variant-picker, product-form)
// re-construct themselves automatically once their markup is re-inserted into the DOM.
document.addEventListener("DOMContentLoaded", function () {
  let isSwapping = false;

  addEventDelegate({
    selector: "[data-ajax-color-swatches] [data-ajax-color-swatch]",
    handler: function (e, target) {
      if (target.classList.contains("product-its-self")) {
        e.preventDefault();
        return;
      }

      const sectionWrapper = document.querySelector('[data-section-type="product-page"]');
      const rightSection = document.querySelector(".right-section");
      const url = target.getAttribute("href");

      if (isSwapping || !sectionWrapper || !rightSection || !url) return;

      e.preventDefault();
      swapProductByUrl(url, sectionWrapper, rightSection);
    },
  });

  // Keep back/forward navigation correct by doing a real reload rather than
  // trying to re-swap from cached state (simpler and always accurate).
  window.addEventListener("popstate", function () {
    window.location.reload();
  });

  function swapProductByUrl(url, sectionWrapper, rightSection) {
    isSwapping = true;
    rightSection.classList.add("is-swapping-product");

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.text();
      })
      .then((html) => {
        const newDoc = new DOMParser().parseFromString(html, "text/html");
        const newRightSection = newDoc.querySelector(".right-section");
        const newSectionWrapper = newDoc.querySelector('[data-section-type="product-page"]');

        if (!newRightSection || !newSectionWrapper) {
          throw new Error("Could not find product content in fetched page");
        }

        rightSection.replaceWith(newRightSection);
        reviveInlineScripts(newRightSection);

        // ".byte1" media items are hidden by default (CSS) and only the one with
        // ".byte-active" is shown. That class is normally set once by main-product.liquid's
        // DOMContentLoaded handler, which never fires again for this swap, so none of the
        // freshly swapped-in items would be visible. Re-apply it to the first item, same as
        // that initial-load logic does.
        const firstByteSlide = newRightSection.querySelector(".byte1.swiper-slidex");
        const firstByteImg = firstByteSlide && firstByteSlide.querySelector("img");
        if (firstByteImg && typeof window.setActiveImage === "function") {
          window.setActiveImage(firstByteImg.src);
        } else if (firstByteSlide && !newRightSection.querySelector(".byte1.byte-active")) {
          firstByteSlide.classList.add("byte-active");
        }

        // Fresh markup ships with .byteLoader visible. The load listeners that hide it
        // only bind on DOMContentLoaded / section:load, so re-bind for the swapped media.
        initByteMediaLoaders(newRightSection);

        ["data-product-handle", "data-product-url", "data-product-id"].forEach((attr) => {
          const value = newSectionWrapper.getAttribute(attr);
          if (value !== null) sectionWrapper.setAttribute(attr, value);
        });

        const newTitle = newDoc.querySelector("title");
        if (newTitle) document.title = newTitle.textContent;

        history.pushState({ stepeviProductSwap: true }, "", url);

        window.dispatchEvent(new CustomEvent("stepevi:product-swapped", { detail: { url } }));
      })
      .catch((error) => {
        console.error("Color swatch product swap failed, navigating instead:", error);
        window.location.href = url;
      })
      .finally(() => {
        isSwapping = false;
        const liveRightSection = document.querySelector(".right-section");
        if (liveRightSection) {
          liveRightSection.classList.remove("is-swapping-product");
        }
      });
  }

  // Inline <script> tags parsed via DOMParser don't execute when inserted into the
  // live document, so some blocks (e.g. the offer price poller, bundle box add-to-cart)
  // would go stale after the swap. Re-create them so they run. External `src` scripts
  // are skipped: they're already loaded/defined (e.g. customElements.define) and re-running
  // them can throw (e.g. "name has already been used").
  function reviveInlineScripts(container) {
    container.querySelectorAll("script:not([src])").forEach((oldScript) => {
      if (oldScript.type && oldScript.type !== "text/javascript") return;
      const newScript = document.createElement("script");
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }
});

function syncMediaAspectRatio(img) {
  const media = img.closest(".byteMedia");
  if (!media) return;

  const imageWidth = Number(img.naturalWidth || img.width || img.dataset.mediaWidth);
  const imageHeight = Number(img.naturalHeight || img.height || img.dataset.mediaHeight);

  if (!imageWidth || !imageHeight) return;

  media.style.setProperty("--byte-media-aspect-ratio", String(imageWidth / imageHeight));
  img.setAttribute("width", String(imageWidth));
  img.setAttribute("height", String(imageHeight));
}

function hideByteMediaLoader(img) {
  const media = img.closest(".byteMedia");
  const column = img.closest(".m-main-product--media");

  syncMediaAspectRatio(img);

  if (media) {
    media.classList.add("media-loaded", "is-loaded");
  }

  if (column) {
    column.classList.add("media-loaded");
  }

  const loader = media && media.querySelector(".byteLoader");
  if (loader) {
    loader.style.display = "none";
  }
}

function initByteMediaLoaders(root) {
  const scope = root || document;
  const images = scope.querySelectorAll(".byteMedia .byte-media-image, .byteMedia > img");

  for (const img of images) {
    if (img.dataset.byteLoaderBound === "true") continue;
    img.dataset.byteLoaderBound = "true";

    if (img.complete) {
      hideByteMediaLoader(img);
      continue;
    }

    img.addEventListener("load", () => hideByteMediaLoader(img), { once: true });
    img.addEventListener("error", () => hideByteMediaLoader(img), { once: true });
  }
}

window.initByteMediaLoaders = initByteMediaLoaders;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initByteMediaLoaders());
} else {
  initByteMediaLoaders();
}

document.addEventListener("shopify:section:load", (event) => {
  initByteMediaLoaders(event.target);
});
